"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { ensureSiteGlueXPixel, shouldLoadSiteGlueXPixel } from "~/lib/siteglue/x-pixel";

/**
 * Loads the native X Website Tag on siteglue.ai and SiteGlue-branded app sessions.
 * Complements GTM so conversion diagnostics are not blocked when GTM tags go quiet.
 */
export function SiteGlueXPixel() {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (!shouldLoadSiteGlueXPixel()) return;
    void ensureSiteGlueXPixel();
  }, [pathname, searchParams]);

  return null;
}
